import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CalendarItemEnum } from 'src/app/models/enums/calendarItemType';
import { EventFormPopupComponent } from 'src/app/shared/components/event-form-popup/event-form-popup.component';

declare var moment: any;
declare var ics: any;

@Component({
  selector: 'app-event-lobby-item',
  templateUrl: './event-lobby-item.component.html',
  styleUrls: ['./event-lobby-item.component.scss', './event-lobby-item.component.en.scss'],
})
export class EventLobbyItemComponent {
  @Input({ required: true }) event!: any;
  @Input({ required: true }) freeEventText!: string;
  @Input({ required: true }) onlineEventText!: string;
  @Input({ required: true }) atHourText!: string;
  @Input({ required: true }) addToDiaryBtnText!: string;
  @Input({ required: true }) registrationEventText!: string;
  @Input() isLoading: boolean = false;
  @Input() antiToken!: string;
  @Input() shareCalendarIcons?: any[];
  @Input() socialShareSettings?: any;

  constructor(public dialog: MatDialog) {}

  get isSameDay(): boolean {
    if (!this.event?.endDate) return true;
    const s = new Date(this.event.startDate);
    const e = new Date(this.event.endDate);
    return s.getFullYear() === e.getFullYear() && s.getMonth() === e.getMonth() && s.getDate() === e.getDate();
  }

  get isSameMonthYear(): boolean {
    if (!this.event?.endDate) return true;
    const s = new Date(this.event.startDate);
    const e = new Date(this.event.endDate);
    return s.getFullYear() === e.getFullYear() && s.getMonth() === e.getMonth();
  }

  addToCalendarClick(type: CalendarItemEnum) {
    switch (type) {
      case CalendarItemEnum.Gmail:
        this.addGoogleCalendarEvent();
        break;
      case CalendarItemEnum.Outlook:
        this.addOutlookCalendarEvent();
        break;
      case CalendarItemEnum.Desktop:
        this.downloadDesktopCalendarEvent();
        break;
      default:
        break;
    }
  }

  private addGoogleCalendarEvent() {
    let startDate = moment(this.event.startDate).utc().format('YYYYMMDDTHHmmss');
    let endDate = moment(this.event.endDate).utc().format('YYYYMMDDTHHmmss');
    let link = [
      'https://www.google.com/calendar/render',
      '?action=TEMPLATE',
      '&text=' + encodeURIComponent(this.event.pageTitle!),
      '&dates=' + startDate + '/' + endDate,
    ];

    if (this.event.shortDescription) {
      link.push('&details=' + encodeURIComponent(this.event.shortDescription));
    }
    if (this.event.location) {
      link.push('&location=' + encodeURIComponent(this.event.location));
    }

    window.open(link.join(''), '_blank');
  }

  private addOutlookCalendarEvent() {
    let startDate = moment(this.event.startDate).utc().format('YYYY-MM-DDTHH:mm:ss');
    let endDate = moment(this.event.endDate)
      .utc()
      .format('YYYY-MM-DDTHH:mm:ss');

    let link = [
      'https://outlook.live.com/calendar/deeplink/compose?path=/calendar/action/compose&rru=add',
      '&startdt=' + encodeURIComponent(startDate),
      '&enddt=' + encodeURIComponent(endDate),
      '&subject=' + encodeURIComponent(this.event.pageTitle!),
    ];

    if (this.event.shortDescription) {
      link.push('&body=' + encodeURIComponent(this.event.shortDescription));
    }

    if (this.event.location) {
      link.push('&location=' + encodeURIComponent(this.event.location));
    }

    window.open(link.join(''), '_blank');
  }

  private downloadDesktopCalendarEvent() {
    let startDate = moment(this.event.startDate).utc().format('YYYY-MM-DDTHH:mm:ss');
    let endDate = moment(this.event.endDate)
      .utc()
      .format('YYYY-MM-DDTHH:mm:ss');
    var cal = ics();
    cal.addEvent(
      this.event.pageTitle,
      this.event.shortDescription,
      this.event.location,
      startDate,
      endDate
    );
    cal.download();
  }

  openRegistrationForm($event: any) {
    $event.preventDefault();
    this.dialog.open(EventFormPopupComponent, {
      panelClass: 'events-lobby-item-popup',
      data: { form: this.event, antitoken: this.antiToken }
    });
  }
}
